import { useConnect } from 'redux-bundler-hook'

import { FileDownload } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

import { parseApiErrors, useSmallScreen } from '@common/utils'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {number} props.interval
 * @param {Object} props.requestParams
 * @param {string} props.requestParams.start
 * @param {string} props.requestParams.end
 * @param {string[]} props.requestParams.metrics
 */
export default function ExportMetrics({ requestParams, interval, ...props }) {
  const isSmallScreen = useSmallScreen()

  const {
    isAtLeastAdmin,
    smokeMetrics,
    smokeMetricsIsLoading,
    smokeMetricsExportIsLoading,
    doExportSmokeMetrics,
    doShowSnackbar,
  } = useConnect(
    'selectIsAtLeastAdmin',
    'selectSmokeMetrics',
    'selectSmokeMetricsIsLoading',
    'selectSmokeMetricsExportIsLoading',
    'doExportSmokeMetrics',
    'doShowSnackbar',
  )

  const payload = { ...requestParams }
  delete payload.metrics // export all available metrics

  const borderColor = isSmallScreen.mobile
    ? 'rgba(72, 64, 186, 0.6)'
    : 'rgba(0, 0, 0, 0.15)'

  return (
    isAtLeastAdmin && (
      <Tooltip title="Export CSV">
        <div>
          <IconButton
            disabled={
              smokeMetricsExportIsLoading || smokeMetricsIsLoading || !smokeMetrics
            }
            loading={smokeMetricsExportIsLoading}
            sx={{
              outline: `1px solid ${borderColor}; border-radius: 2px;`,
              '& .MuiTouchRipple-root .MuiTouchRipple-child': {
                borderRadius: '2px',
              },
              mb: 0.2,
              p: 0.75,
            }}
            size="small"
            color={isSmallScreen.mobile ? 'primary' : 'default'}
            onClick={async () => {
              try {
                await doExportSmokeMetrics(payload, interval)
              } catch (err) {
                const parsedError = parseApiErrors(err?.response)
                doShowSnackbar(parsedError, 'error')
              }
            }}
            {...props}
          >
            <FileDownload sx={{ fontSize: isSmallScreen.mobile ? 21 : 24 }} />
          </IconButton>
        </div>
      </Tooltip>
    )
  )
}
